export enum FilterActionType {
  DRILLDOWN_SET_FILTER_STRING = 'DRILLDOWN_SET_FILTER_STRING',
}
